/**
 * #144 — per-line return eligibility from Shopify fulfillment.
 *
 * A customer must not be able to request a return on a line that isn't fulfilled in Shopify (those
 * can never be created — empty `returnableFulfillments` — and end up "blocked"). xConnector supplies
 * `fulfilled_quantity` per line (`max(0, ordered − fulfillable)`); the form caps each line at it.
 *
 * Fail-open: when `fulfilledQuantity` is null/undefined (older xConnector that doesn't send it), fall
 * back to the ordered quantity rather than wrongly blocking a return.
 */
export function computeReturnable(
  orderedQuantity: number,
  fulfilledQuantity: number | null | undefined,
  returnableQuantity?: number | null
): { maxReturnable: number; notReturnable: boolean } {
  // Fail open to the ordered quantity when fulfilled is unknown; otherwise cap at fulfilled.
  const ceiling =
    fulfilledQuantity === null || fulfilledQuantity === undefined
      ? orderedQuantity
      : Math.min(orderedQuantity, Math.max(0, fulfilledQuantity));
  // Never negative (guards a 0/negative ordered quantity or a negative fulfilled value).
  const maxReturnable = Math.max(
    0,
    typeof returnableQuantity === 'number'
      ? Math.min(ceiling, returnableQuantity)
      : ceiling
  );
  return { maxReturnable, notReturnable: maxReturnable <= 0 };
}
